import {legacy_createStore,applyMiddleware} from "redux"
import CombineReducer from "./Reducers/CombineReducer"
import thunk from 'redux-thunk'
import logger from "redux-logger"

const reduxstore=legacy_createStore(CombineReducer,applyMiddleware(logger,thunk))
export default reduxstore